<template>
    <div>
        <transition name="fadeInUp">
            <div class="room-count"  v-show="isRoomCountShow">
                <ul>
                    <li @click="RoomCount(1)">1间</li>
                    <li @click="RoomCount(2)">2间</li>
                    <li @click="RoomCount(3)">3间</li>
                    <li @click="RoomCount(4)">4间</li>
                    <li @click="RoomCount(5)">5间</li>
                    <li @click="RoomCount(6)">6间</li>
                    <li @click="RoomCount(7)">7间</li>
                    <li @click="RoomCount(8)">8间</li>
                </ul>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        name: "roomCount",
        props:{
            isRoomCountShow:{
                type:Boolean,
                default:false,
            },
        },
        data: function () {
            return {}
        },

        mounted() {

        },
        methods: {
            RoomCount(val){
                this.$emit('select',val);
            },
        }
    }
</script>

<style scoped>
    .room-count{
        position: absolute;
        top: 36px;
        left: -1px;
        width: 100px;
        border: 1px solid #e6e6e6;
        background: #FFF;
        z-index: 2;
    }
    .room-count ul li{
        padding: 0px 10px;
        cursor: pointer;
        height: 30px;
        line-height: 30px;
    }
    .room-count ul li:hover{
        color: #fff;
        background: #1270f8;
    }
</style>


// WEBPACK FOOTER //
// src/common/cmpnt/searchBox/roomCount.vue